import { render, staticRenderFns } from "./ArchivarPreaspirante.vue?vue&type=template&id=76879fca"
import script from "./ArchivarPreaspirante.vue?vue&type=script&lang=js"
export * from "./ArchivarPreaspirante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports